<template>
  <div class="start">
    <transition name="fade">
      <anime-sort-start-title :isVisible="false" v-show="title" />
    </transition>
    <p class="start-text" :class="{'is-visible': text}">
      自分の肌に合ったアイテムを探すのって、<br class="sp">時間がかかるし、けっこう難しい……。<br><br class="sp">
      VOICES For Youでは、<br class="sp">いくつかの質問にお答えいただくことで、<br>
      あなたに近い肌タイプの方が書いた<br class="sp">スキンケア・ベースメイク商品のレビューを<br class="sp">ご紹介いたします。<br><br class="sp">
      あなたにぴったりのアイテム探しに<br class="sp">ぜひご活用ください。
    </p>
    <button class="start-button" :class="{'is-visible': button}" @click="$emit('clickedButton')">
      <img class="start-button-chara start-button-chara--s" src="@/assets/images/start_s.svg" alt="S" />
      <img class="start-button-chara start-button-chara--t" src="@/assets/images/start_t.svg" alt="T" />
      <img class="start-button-chara start-button-chara--a" src="@/assets/images/start_a.svg" alt="A" />
      <img class="start-button-chara start-button-chara--r" src="@/assets/images/start_r.svg" alt="R" />
      <img class="start-button-chara start-button-chara--t" src="@/assets/images/start_t.svg" alt="T" />
    </button>
  </div>
</template>

<script>
import AnimeSortStartTitle from './AnimeSortStartTitle.vue';
export default {
  components: { AnimeSortStartTitle },
  name: 'PageSortStart',
  data: () => {
    return {
      title: false,
      text: false,
      button: false
    }
  },
  methods: {
    show() {
      // setTimeout(() => {
      //   this.title = true;
      // }, 1000);
      // setTimeout(() => {
      //   this.text = true;
      // }, 2600);
      // setTimeout(() => {
      //   this.button = true;
      // }, 3200);
      setTimeout(() => {
        this.title = true;
        this.text = true;
        this.button = true;
      }, 1000);
    },
    hide() {
      this.title = false;
      this.text = false;
      this.button = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.start {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 64/375 * 100% 0 63/375 * 100%;
  position: absolute;
  top: 0;
  left: 0;
  &-title {
    width: 246/375 * 100%;
    margin: 0 auto;
    @include media() {
      width: 488px;
      height: 20px;
      background: url(~@/assets/images/text_mv_02_pc.svg) center/contain no-repeat;
    }
    img {
      @include media() {
        height: 0;
      }
    }
  }
  &-text {
    display: block;
    text-align: center;
    margin: 40/375 * 100% 0;
    font-size: 11/375 * 100vw;
    line-height: (24/11);
    letter-spacing: .1em;
    opacity: 0;
    transition: opacity .9s ease;
    &.is-visible {
      opacity: 1;
    }
    @include media() {
      font-size: 13px;
      line-height: (32/13);
      margin: 40px 0 60px;
    }
  }
  &-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 200/375 * 100%;
    border: 1px solid #DF0168;
    border-radius: 23/375 * 100vw;
    padding: 18/375 * 100% 0;
    opacity: 0;
    transition: opacity .9s ease;
    &.is-visible {
      opacity: 1;
    }
    @include media() {
      width: 200px;
      padding: 17px 0;
      border-radius: 45px;
      backface-visibility: hidden;
      &:hover{
        cursor: pointer;
        .start-button-chara {
          margin: 0 6px;
        }
      }
    }
    &-chara {
      margin: 0 3/375 * 100vw;
      @include media() {
        margin: 0 3px;
        backface-visibility: hidden;
        transition: .6s ease;
      }
      &--s {
        width: 5.17/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 6px;
          height: 10px;
          margin-right: 4px;
        }
      }
      &--t {
        width: 6.91/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 8px;
          height: 10px;
        }
      }
      &--a {
        width: 7.77/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 9px;
          height: 10px;
          margin-right: 5px;
        }
      }
      &--r {
        width: 6.91/375 * 100vw;
        height: 8.63/375 * 100vw;
        @include media() {
          width: 8px;
          height: 10px;
        }
      }
    }
  }
}
</style>
